import pre from './pre';
import post from './post';
import config from './config/index.vue';
import cart from './cart.vue';
import success from './success.vue';

export default {
  pre,
  components: {
    config,
    cart,
    success,
  },
  post,
};
